import { useLocation } from 'react-router-dom';
import {  routerCompare } from './routes';

/**
 * @returns {import('./routes').Route}
 */
export const useRouteInfo = () => {
    const m = useMatch();

    // @ts-ignore
    return m?.[0]?.route?.routeInfo?.[1] ?? {}
}
export const useParams = () => {
    const m = useMatch();

    // @ts-ignore
    return m?.[0]?.params ?? {}
}

const useMatch = () => {
    const location = useLocation();
    const m = routerCompare(location);

    return m;
}
